import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProductCategoriesComponent } from './product-categories.component';

const routes: Routes = [
  {
    path: '',
    component: ProductCategoriesComponent,
  },
  {
    path: 'detail/:id',
    component: ProductCategoriesComponent,
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'prefix',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProductCategoriesRoutingModule {}
